import React from 'react';
import { PRODUCT_GROUPS } from '../pages/compliance/productOptions';

/**
 * Multi-select checklist of products the client is applying for, grouped by
 * Insurance and Investment/Registered. Controlled: `value` is an array of
 * product slugs; `other` is the free-text for "Other".
 */
export const ProductSelector = ({ value = [], onChange, other = '', onOtherChange, testidPrefix = 'product' }) => {
  const toggle = (slug) => {
    const next = value.includes(slug) ? value.filter((v) => v !== slug) : [...value, slug];
    onChange(next);
  };
  const showOther = value.includes('other_insurance') || value.includes('other_investment');
  return (
    <div className="space-y-4" data-testid={`${testidPrefix}-selector`}>
      {PRODUCT_GROUPS.map((group) => (
        <div key={group.category}>
          <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">{group.category}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {group.options.map((opt) => {
              const checked = value.includes(opt.value);
              return (
                <label
                  key={opt.value}
                  className={`flex items-center gap-2 px-3 py-2 border rounded-lg cursor-pointer text-sm transition-colors ${checked ? 'bg-[#0077B6]/10 border-[#0077B6] text-[#0A2A43] font-medium' : 'border-gray-200 hover:border-gray-300'}`}
                  data-testid={`${testidPrefix}-opt-${opt.value}`}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggle(opt.value)}
                    className="w-4 h-4 accent-[#0077B6]"
                  />
                  {opt.label}
                </label>
              );
            })}
          </div>
        </div>
      ))}
      {showOther && (
        <div>
          <label className="block text-sm font-medium mb-1">Other product(s) — please specify</label>
          <input
            type="text"
            value={other}
            onChange={(e) => onOtherChange(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0077B6]"
            data-testid={`${testidPrefix}-other`}
          />
        </div>
      )}
    </div>
  );
};

export default ProductSelector;
